import { useContent } from "contexts/contentContext/contentContext.js";
import { useState, useRef, useEffect } from "react";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import Icon from "../../Elements/Icon/Icon.tsx";

import "./SelectElement.scss";

const SelectElement = ({ list, item, setItem, title }) => {
  const elementRef = useRef();
  const [tempList, setTempList] = useState(list);
  const { getTextByKey } = useContent();
  const defaultTitle = getTextByKey(title || "select-country");
  const [tempItem, setTempItem] = useState(item ? item : "");

  useEffect(() => {
    if (item !== null && !item !== undefined) {
      setTempItem(item);
    }
  }, [item]);

  const [openList, setOpenList] = useState(false);
  const handleChange = (e) => {
    setTempItem(e.target.value);
    if (e.target.value !== getTextByKey("select-country")) {
      autoCompleteList(e.target.value);
    }
  };

  useEffect(() => {
    setTempList(list);
  }, [openList, list]);

  const handleFocus = (e) => {
    setOpenList(true);
  };

  useOnClickOutside(elementRef, () => closeList());

  const autoCompleteList = (val) => {
    setTempList(
      list.filter((item) => item.toLowerCase().startsWith(val.toLowerCase()))
    );
  };

  const closeList = () => {
    //check if item is in list
    if (list.includes(tempItem)) {
      setItem(tempItem);
    } else {
      setTempItem(item);
    }
    setTempList(list);
    setOpenList(false);
  };

  const selectItem = (item) => {
    setTempItem(item);
    setItem(item);
    setOpenList(false);
  };

  return (
    <div className="select-list-element" ref={elementRef}>
      <div className="select-list-input">
        <input
          type="text"
          value={tempItem}
          onChange={handleChange}
          onFocus={handleFocus}
          placeholder={defaultTitle}
        />
      </div>
      <div className={`list-container ${openList ? "open" : "close"}`}>
        {tempList.length > 0 &&
          tempList.map((item, i) => (
            <div
              key={i}
              className="item-container"
              onClick={() => selectItem(item)}
            >
              {item}
            </div>
          ))}
      </div>
    </div>
  );
};

export default SelectElement;
